module.exports = __webpack_public_path__ + "files/d8f88ddaf3e24f81f90d0c05dbc2c3ec.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/exo2-italic-webfont.woff2
 ** module id = 919
 ** module chunks = 0
 **/